import { render, staticRenderFns } from "./Voorstellen.vue?vue&type=template&id=26baee4a&"
import script from "./Voorstellen.vue?vue&type=script&lang=js&"
export * from "./Voorstellen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports